import { AdjustButton } from '../../components';

type CompactClockButtonsProps = {
  onAdd: (amount: number) => void;
  onSubtract: (amount: number) => void;
  mainClockTime: number;
};

const getLabel = (amount: number, add: boolean) => `${add ? '+' : '-'}${amount}s`;

const CompactClockButtons = ({ onAdd, onSubtract, mainClockTime }: CompactClockButtonsProps) => (
  <div className="w-full flex gap-3.5 justify-between">
    <div className="flex gap-2">
      <AdjustButton onClick={() => onSubtract(1)} disabled={mainClockTime <= 0}>
        {getLabel(1, false)}
      </AdjustButton>
      <AdjustButton onClick={() => onAdd(1)}>{getLabel(1, true)}</AdjustButton>
    </div>
    <div className="flex gap-2">
      <AdjustButton onClick={() => onSubtract(5)} disabled={mainClockTime <= 0}>
        {getLabel(5, false)}
      </AdjustButton>
      <AdjustButton onClick={() => onAdd(5)}>{getLabel(5, true)}</AdjustButton>
    </div>
  </div>
);

export default CompactClockButtons;
